import React from "react";

// Views
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import SignIn from "views/auth/SignIn";
import AppsPage from "views/admin/appsPage";
import PaymentGatewayPage from "views/admin/PaymentGateway";

// Icons
import {
  MdHome,
  MdBarChart,
  MdPerson,
  MdPayments,
  MdAppRegistration,
  MdSupportAgent,
  MdApps,
  MdDashboard,
  MdVideoCall,
  MdChat,
  MdInsights,
  MdNotificationsActive,
  MdSecurity,
  MdSettings,
  MdListAlt,
  MdOutlineApps,
  MdAttachMoney,
  MdNotifications,
  MdBackup,
  MdOutlineEvent,
  MdGroup,
  MdHouseboat,
} from "react-icons/md";
import AgentPage from "views/admin/Agent";
import Marketplace from "views/admin/marketplace";
import TransectionPage from "views/admin/transectionPage";
import TransactionDetailsPage from "views/admin/transectionPage/TramsectionDetailsPage";
import TablesAppAdmin from "views/admin/tables";
import AudioLogs from "views/admin/AudioLogs";
import VidoeLogs from "views/admin/VideoLogs";

// Get user role from localStorage
const AdminDetails = JSON.parse(localStorage.getItem("user"));
const role = AdminDetails?.admin?.role || "";

const commonRoutes = [
  {
    name:
      role === "superAdmin"
        ? "Admin Dashboard"
        : role === "agent"
        ? "Agent Dashboard"
        : "App Admin Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    hideInSidebar: false,
  },
];

const roleBasedRoutes = {
  superAdmin: [

  {
    name: "App Admins",
    layout: "/admin",
    path: "app-admin",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: <TablesAppAdmin type="admins" />,
    hideInSidebar: false,
  },
    {
    name: "Agent",
    layout: "/admin",
    path: "agent-admin",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: <AgentPage type="admins" />,
    hideInSidebar: false,
  },
  {
    name: "All Users",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Marketplace type="user" />,
    hideInSidebar: false,
  },
    {
    name: "All Host",
    layout: "/admin",
    path: "hosts",
    icon: <MdHouseboat className="h-6 w-6" />,
    component: <Marketplace type="host" />,
    hideInSidebar: false,
  },
  {
    name: "All Apps",
    layout: "/admin",
    path: "apps",
    icon: <MdOutlineApps className="h-6 w-6" />,
    component: <AppsPage type="apps" />,
    hideInSidebar: false,
  },
  {
    name: "Payment Gateways",
    layout: "/admin",
    path: "payment-gateways",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <PaymentGatewayPage type="payment-gateways" />,
    hideInSidebar: false,
  },
  {
    name: "Transactions",
    layout: "/admin",
    path: "transactions",
    icon: <MdListAlt className="h-6 w-6" />,
    component: <TransectionPage type="transactions-all" />,
    hideInSidebar: false,
  },
     {
    name: "Transaction Logs",
    layout: "/admin",
    path: "/transection-details/:id",
    icon: <MdListAlt className="h-6 w-6" />,
   component: <TransactionDetailsPage type="transactions-all" />,
    hideInSidebar: true,
  },
  {
    name: "Audio Logs",
    layout: "/admin",
    path: "chat-logs",
    icon: <MdChat className="h-6 w-6" />,
    component: <AudioLogs type="chat" />,
    hideInSidebar: false,
  },
  {
    name: "Video Call Logs",
    layout: "/admin",
    path: "call-logs",
    icon: <MdVideoCall className="h-6 w-6" />,
    component: <VidoeLogs type="calls" />,
    hideInSidebar: false,
  },
  {
    name: "Push Notifications",
    layout: "/admin",
    path: "notifications",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <NFTMarketplace type="notifications" />,
    hideInSidebar: false,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <NFTMarketplace type="settings" />,
    hideInSidebar: false,
  },
  {
    name: "Content Moderation",
    layout: "/admin",
    path: "moderation",
    icon: <MdSecurity className="h-6 w-6" />,
    component: <NFTMarketplace type="moderation" />,
    hideInSidebar: false,
  },
  {
    name: "Analytics",
    layout: "/admin",
    path: "analytics",
    icon: <MdInsights className="h-6 w-6" />,
    component: <NFTMarketplace type="analytics" />,
    hideInSidebar: false,
  },
  {
    name: "Backups",
    layout: "/admin",
    path: "backups",
    icon: <MdBackup className="h-6 w-6" />,
    component: <NFTMarketplace type="backups" />,
    hideInSidebar: false,
  }
],
  appAdmin:[

  {
    name: "User Management",
    layout: "/admin",
    path: "users/:appId?",
    icon: <MdPerson className="h-6 w-6" />,
    component: <NFTMarketplace type="user" />,
    hideInSidebar: false,
  },
  {
    name: "Transaction Logs",
    layout: "/admin",
    path: "transactions",
    icon: <MdListAlt className="h-6 w-6" />,
   component: <TransectionPage type="transactions-app" appId={AdminDetails?.admin?.appID} />,
    hideInSidebar: false,
  },
    {
    name: "Transaction Logs",
    layout: "/admin",
    path: "/transection-details/:id",
    icon: <MdListAlt className="h-6 w-6" />,
   component: <TransactionDetailsPage type="transactions-app" appId={AdminDetails?.admin?.appID} />,
    hideInSidebar: true,
  },
  {
    name: "Audio Logs",
    layout: "/admin",
    path: "audio-logs",
    icon: <MdChat className="h-6 w-6" />,
    component: <NFTMarketplace type="chat" />,
    hideInSidebar: false,
  },
  {
    name: "Video Call Logs",
    layout: "/admin",
    path: "call-logs",
    icon: <MdVideoCall className="h-6 w-6" />,
    component: <NFTMarketplace type="calls" />,
    hideInSidebar: false,
  },
  {
    name: "Reports & Analytics",
    layout: "/admin",
    path: "analytics",
    icon: <MdInsights className="h-6 w-6" />,
    component: <NFTMarketplace type="analytics" />,
    hideInSidebar: false,
  },
  {
    name: "Support Tickets",
    layout: "/admin",
    path: "support",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: <NFTMarketplace type="support" />,
    hideInSidebar: false,
  },
  {
    name: "Push Notifications",
    layout: "/admin",
    path: "notifications",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: <NFTMarketplace type="notifications" />,
    hideInSidebar: false,
  },
  {
    name: "Content Moderation",
    layout: "/admin",
    path: "moderation",
    icon: <MdSecurity className="h-6 w-6" />,
    component: <NFTMarketplace type="moderation" />,
    hideInSidebar: false,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <NFTMarketplace type="settings" />,
    hideInSidebar: false,
  },
],
  agent: [

  {
    name: "Host",
    layout: "/admin",
    path: "host",
    icon: <MdOutlineEvent className="h-6 w-6" />,
    component: <NFTMarketplace type="host" />,
    hideInSidebar: false,
  },
  {
    name: "My Users",
    layout: "/admin",
    path: "my-users",
    icon: <MdGroup className="h-6 w-6" />,
    component: <NFTMarketplace type="my-users" />,
    hideInSidebar: false,
  },
  {
    name: "Chat History",
    layout: "/admin",
    path: "my-chat-logs",
    icon: <MdChat className="h-6 w-6" />,
    component: <NFTMarketplace type="my-chat" />,
    hideInSidebar: false,
  },
  {
    name: "Call History",
    layout: "/admin",
    path: "my-call-logs",
    icon: <MdVideoCall className="h-6 w-6" />,
    component: <NFTMarketplace type="my-calls" />,
    hideInSidebar: false,
  },
  {
    name: "Profile Settings",
    layout: "/admin",
    path: "profile",
    icon: <MdSettings className="h-6 w-6" />,
    component: <NFTMarketplace type="agent-profile" />,
    hideInSidebar: false,
  },
  ],
};

// Always available routes
const utilityRoutes = [
  {
    name: "User Details",
    layout: "/user-details",
    path: "users-details",
    icon: <MdPerson className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
    hideInSidebar: false,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdAppRegistration className="h-6 w-6" />,
    component: <SignIn />,
    secondary: false,
    hideInSidebar: true,
  },
  {
    name: "RTL Admin",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
    hideInSidebar: true,
  },
];

// Final route export
const routes = [
  ...commonRoutes,
  ...(roleBasedRoutes[role] || []),
  ...utilityRoutes,
];

export default routes;
